/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { ActionBar } from './action-bar';
import { TabBar } from './tab-bar';

import { ContentRow } from './content-row';
import { TableGrid } from './table-grid';
import { TextArea } from './text-area';
import { TextInput } from './text-input';
import { HiddenInput } from './hidden-input';
import { TextView } from './text-view';

import { DateInput } from './date-input';
import { NumberInput } from './number-input';

import { StaticSelect, ValidSelect } from './zeta-select';
import { ZetaElement } from './zeta-element';
import { NumberSpin } from './number-spin';
import { ZetaDataList } from './zeta-datalist';
import { DropDownAction } from './drop-down-action';

export function ZetaChild(props) {
  const { em, data } = props;

  let _show = true;

  if (typeof em?.showBy !== 'undefined') {
    const criteria = em.showBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1 && typeof data[_fld]==='string') {
        _show = (data[_fld].trim()!=='' 
          && data[_fld].match(new RegExp(criteria[1], 'i'))) ? true : false;
      } else {
        _show = (data[_fld]===true || `${data[_fld]}`.match(/1|A|Y/i)) ? true : false;
      }
    } else {
      _show = false;
    }
    
    if (criteria.length > 1 && criteria[1].match(/null|empty|false/i)) {
      _show = !data[_fld] || `${data[_fld]}`.trim()==='';
    }

  }

  if (!_show) return null;

  switch (em.type) {
    case 'ActionBar':
      return <ActionBar {...props} />;

    case 'TabBar':
      return <TabBar {...props} />;

    case 'ContentRow':
      return <ContentRow {...props} />;

    case 'Table':
      return <TableGrid {...props} />;

    case 'TextArea':
      return <TextArea {...props} />;

    case 'TextInput':
      return <TextInput {...props} />;

    case 'HiddenInput':
      return <HiddenInput {...props} />;

    case 'TextView':
      return <TextView {...props} />;

    case 'DateInput':
      return <DateInput {...props} />;

    case 'NumberInput':
      return <NumberInput {...props} />;

    case 'NumberSpin':
      return <NumberSpin {...props} />;
  
    case 'StaticSelect':
      return <StaticSelect {...props} />;

    case 'ValidSelect':
      return <ValidSelect {...props} />;

    case 'DataList':
      return <ZetaDataList {...(props.em || props)} />

    case 'DropDownAction':
      return <DropDownAction {...props} />;

    case 'HtmlTag':
      return <ZetaElement {...props} />

    default:
      return null;
  }
}

ZetaChild.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any
}